import React, { useMemo, useEffect, useState } from "react";
import Table from "../../../Components/Table/index";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import Spinner from "react-bootstrap/Spinner";
import AlertMessage from "../../../Components/AlertMessage";
import { API_CONSTANTS } from "../../../API_CONSTANTS";
import Toast from "../../../Components/Toast/Toast";
import Modal from "react-bootstrap/Modal";
import EditSurgeryModal from "./EditSurgeryModal";
import SurgeryOverview from "./SurgeryOverview";
import {
  faCheckCircle,
  faTimesCircle,
  faInfoCircle,
  faFileMedical,
  faUserMd,
  faTag,
  faCogs,
  faIdBadge,
  faImage,
  faUser,
  faStethoscope,
  faCalendarAlt,
  faStar,
  faClinicMedical,
  faHospital,
  faMapMarkerAlt,
  faAddressBook,
  faDollarSign,
  faAlignLeft,
  faTrashAlt,
  faEye,
} from "@fortawesome/fontawesome-free-solid";

//Delete Function Component
function Delete({ data, surgery }) {
  const [show, setShow] = useState(false);
  const [showOverview, setShowOverview] = useState(false);
  const [deletedSurgery, setDeletedSurgery] = useState(null);
  const handleClose = () => {
    setShow(false);
    setShowOverview(false);
    setDeletedSurgery(null);
  };
  const handleShow = () => setShow(true);
  const [ToastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState("");
  const [ToastIcon, setToastIcon] = useState(faTimesCircle);
  const [iconColor, setIconColor] = useState("");
  const [loading, setLoading] = useState(false);

  const handleToast = (message, icon, iconColor, className) => {
    setToastIcon(icon);
    setToastMessage(message);
    setShowToast(`show ${className}`);
    setIconColor(iconColor);
    setTimeout(() => setShowToast(""), 2900);
  };

  const handleDelete = () => {
    setLoading(true);
    axios
      .delete(`${API_CONSTANTS.BASEURL_5}admin/delete_procedure_and_surgery`, {
        data: {
          procedure_id: data.id
        },
        headers: API_CONSTANTS.headers(),
      })
      .then((res) => {
        setLoading(false);
        if (res.data?.response?.message === "Procedure/Surgery deleted successfully" || res.data.message === "Success") {
          handleToast(
            "Procedure/Surgery Deleted Successfully",
            faCheckCircle,
            "#009b94",
            "show-success"
          );
          setDeletedSurgery(data);
          setShow(false);
          setShowOverview(true);
          surgery(); // Refresh the list
        }
      })
      .catch((error) => {
        setLoading(false);
        handleToast(
          "Error deleting procedure/surgery",
          faTimesCircle,
          "#dc3545",
          "show-error"
        );
      });
  };

  return (
    <>
      <button className="Deleted" onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        e.nativeEvent?.stopImmediatePropagation?.();
        handleShow();
        return false;
      }}>
        <i className="fas fa-trash-alt" style={{ color: "#FF6760" }}></i>{" "}
        Delete
      </button>
      <Modal show={show}>
        <Modal.Header>
          <Modal.Title style={{ fontSize: 18 }}>Caution!</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete this Procedure/Surgery?
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn"
            style={{
              border: "1px solid #79747E",
              color: "#B00020",
              background: "none",
            }}
            onClick={handleClose}
          >
            Close
          </button>
          <button
            className="btn"
            style={{ background: "#009B93", color: "#fff" }}
            onClick={handleDelete}
          >
            {loading && (
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
            )}{" "}
            Delete
          </button>
        </Modal.Footer>
      </Modal>

      {/* Overview Modal */}
      <Modal show={showOverview} size="lg" onHide={handleClose} centered>
        <Modal.Header closeButton className="bg-light">
          <Modal.Title className="text-danger">
            <i className="fas fa-trash-alt me-2"></i>
            Deleted Surgery Overview
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          {deletedSurgery && (
            <div className="surgery-overview-modal">
              {/* General Information */}
              <div className="mb-4">
                <h5 className="text-primary mb-3 border-bottom pb-2">
                  <i className="fas fa-info-circle me-2"></i>
                  General Information
                </h5>
                <div className="row g-3">
                  <div className="col-md-6">
                    <div className="p-3 bg-light rounded">
                      <div className="mb-2">
                        <strong className="text-muted">Procedure Name:</strong><br />
                        <span className="text-dark">{deletedSurgery.procedure_name || 'N/A'}</span>
                      </div>
                      <div className="mb-2">
                        <strong className="text-muted">Type:</strong><br />
                        <span className="text-dark">{deletedSurgery.procedure_type || 'N/A'}</span>
                      </div>
                      <div className="mb-2">
                        <strong className="text-muted">ID:</strong><br />
                        <span className="text-dark">{deletedSurgery.id || 'N/A'}</span>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    {deletedSurgery.procedure_image_url ? (
                      <div className="p-3 bg-light rounded text-center">
                        <strong className="text-muted d-block mb-2">Procedure Image</strong>
                        <img 
                          src={deletedSurgery.procedure_image_url} 
                          alt="Procedure" 
                          className="img-fluid rounded shadow-sm" 
                          style={{ maxHeight: '150px', objectFit: 'cover' }}
                          onError={(e) => {
                            e.target.style.display = 'none';
                            e.target.nextSibling.style.display = 'block';
                          }}
                        />
                        <div className="text-muted small mt-2" style={{ display: 'none' }}>
                          <i className="fas fa-image me-1"></i>
                          Image not available
                        </div>
                      </div>
                    ) : (
                      <div className="p-3 bg-light rounded text-center">
                        <div className="text-muted">
                          <i className="fas fa-image fa-2x mb-2"></i>
                          <br />
                          <small>No image available</small>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* Doctors Section */}
              <div className="mb-4">
                <h5 className="text-success mb-3 border-bottom pb-2">
                  <i className="fas fa-user-md me-2"></i>
                  Doctors ({deletedSurgery.doctors?.length || 0})
                </h5>
                {deletedSurgery.doctors && deletedSurgery.doctors.length > 0 ? (
                  <div className="row g-3">
                    {deletedSurgery.doctors.map((doctor, index) => (
                      <div key={doctor.doctor_id || index} className="col-lg-6">
                        <div className="p-3 border rounded bg-white shadow-sm h-100">
                          <div className="mb-2">
                            <strong className="text-primary">
                              <i className="fas fa-user me-2"></i>
                              {doctor.name || doctor.doctor_name || 'N/A'}
                            </strong>
                          </div>
                          <div className="mb-2">
                            <strong className="text-muted">Specialization:</strong><br />
                            <span className="text-dark">{doctor.specialization || doctor.doctor_specialization || 'N/A'}</span>
                          </div>
                          {doctor.experience && (
                            <div className="mb-2">
                              <strong className="text-muted">Experience:</strong><br />
                              <span className="text-dark">{doctor.experience} years</span>
                            </div>
                          )}
                          {doctor.rating && (
                            <div className="mb-2">
                              <strong className="text-muted">Rating:</strong><br />
                              <span className="text-warning">
                                <i className="fas fa-star me-1"></i>
                                {doctor.rating}
                              </span>
                            </div>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="text-muted p-3 bg-light rounded">
                    <i className="fas fa-info-circle me-2"></i>
                    No doctor information available
                  </div>
                )}
              </div>

              {/* Clinic & Pricing Details */}
              {deletedSurgery.doctors && deletedSurgery.doctors.length > 0 && (
                <div className="mb-4">
                  <h5 className="text-info mb-3 border-bottom pb-2">
                    <i className="fas fa-clinic-medical me-2"></i>
                    Clinic & Pricing Details
                  </h5>
                  <div className="row g-3">
                    {deletedSurgery.doctors.map((doctor, index) => (
                      <div key={doctor.doctor_id || index} className="col-12">
                        <div className="p-3 border rounded bg-white shadow-sm">
                          <h6 className="text-primary mb-3">
                            <i className="fas fa-user-md me-2"></i>
                            {doctor.name || doctor.doctor_name || 'N/A'}
                          </h6>
                          <div className="row g-3">
                            <div className="col-md-6">
                              <div className="mb-2">
                                <strong className="text-muted">Clinic Name:</strong><br />
                                <span className="text-dark">{doctor.clinic?.name || doctor.clinic_name || 'N/A'}</span>
                              </div>
                              <div className="mb-2">
                                <strong className="text-muted">City:</strong><br />
                                <span className="text-dark">{doctor.clinic?.city || doctor.city || 'N/A'}</span>
                              </div>
                              <div className="mb-2">
                                <strong className="text-muted">Address:</strong><br />
                                <span className="text-dark">{doctor.clinic?.address || doctor.clinic_address || 'N/A'}</span>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="mb-2">
                                <strong className="text-muted">Price:</strong><br />
                                <span className="text-success fw-bold">
                                  {doctor.currency || deletedSurgery.currency || 'PKR'} {doctor.pricing || 'N/A'}
                                </span>
                              </div>
                              {doctor.image_url ? (
                                <div className="mt-2">
                                  <strong className="text-muted d-block mb-2">Doctor Image</strong>
                                  <img 
                                    src={doctor.image_url} 
                                    alt="Doctor" 
                                    className="img-fluid rounded shadow-sm" 
                                    style={{ maxHeight: '100px', objectFit: 'cover' }}
                                    onError={(e) => {
                                      e.target.style.display = 'none';
                                      e.target.nextSibling.style.display = 'block';
                                    }}
                                  />
                                  <div className="text-muted small mt-1" style={{ display: 'none' }}>
                                    <i className="fas fa-image me-1"></i>
                                    Image not available
                                  </div>
                                </div>
                              ) : (
                                <div className="mt-2">
                                  <div className="text-muted small">
                                    <i className="fas fa-user-md me-1"></i>
                                    No image available
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Description */}
              <div>
                <h5 className="text-secondary mb-3 border-bottom pb-2">
                  <i className="fas fa-align-left me-2"></i>
                  Description
                </h5>
                <div className="p-3 bg-light rounded">
                  <p className="mb-0 text-dark">{deletedSurgery.description || 'No description available'}</p>
                </div>
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer className="bg-light">
          <button className="btn btn-outline-secondary" onClick={handleClose}>
            <i className="fas fa-times me-2"></i>
            Close
          </button>
        </Modal.Footer>
      </Modal>

      <Toast
        cName={showToast}
        icon={ToastIcon}
        color={iconColor}
        text={ToastMessage}
      />
      <style jsx="true">{`
        .Deleted {
          border: none !important;
          background: none !important;
          padding: 3px 6px;
          border-radius: 4px;
        }
        .Deleted:hover {
          background: #b5c9c8 !important;
        }
      `}</style>
    </>
  );
}

export default function SurgeryList() {
  const [lastEvaluatedKey, setLastEvaluatedKey] = useState("");
  const [surgeryList, setSurgeryList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error] = useState(null);
  const [pageCount, setPageCount] = useState(0);
  const [showOverviewModal, setShowOverviewModal] = useState(false);
  const [overviewSurgery, setOverviewSurgery] = useState(null);
  const [selectedSurgery, setSelectedSurgery] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const fetchIdRef = React.useRef(0);
  const dispatch = useDispatch();

  const filter_status = {
    surgery_name: useSelector((state) => state.SurgeryFilterReducer?.value || ""),
    status: useSelector((state) => state.SurgeryFilterReducer?.value1 || ""),
  };

  const handleFilters = () => {
    let filterData = {
      surgery_name: `${filter_status.surgery_name ? filter_status.surgery_name : ""}`,
      status: `${filter_status.status ? filter_status.status : ""}`,
    };
    if (Object.values(filterData).every((key) => key === "")) {
      return {};
    } else
      return Object.fromEntries(
        Object.entries(filterData).filter(([key, value]) => value !== "")
      );
  };

  const fetchData = React.useCallback(
    ({ pageSize, pageIndex, forceRefresh = false }) => {
      const fetchId = lastEvaluatedKey;
      if (!forceRefresh && fetchId === fetchIdRef.current) return;
      fetchIdRef.current = fetchId;

      setIsLoading(true);

      const queryParams = new URLSearchParams({
        limit: pageSize,
        ...(lastEvaluatedKey && { lastEvaluatedKey }),
        ...handleFilters(),
      });

      axios
        .get(`${API_CONSTANTS.GET_PROCEDURE_AND_SURGERY()}?${queryParams}`, {
          headers: API_CONSTANTS.headers(),
        })
        .then((res) => {
          const surgeries = (res.data?.response?.procedure_and_surgeries || []).filter(s => s && s.id);
          setSurgeryList(surgeries);
          setPageCount(Math.ceil(surgeries.length / pageSize));
          setLoading(false);
          setIsLoading(false);
        })
        .catch((error) => {
          setLoading(false);
          setIsLoading(false);
        });
    },
    [lastEvaluatedKey]
  );

  useEffect(() => {
    fetchData({ pageSize: 10, pageIndex: 0 });
  }, [fetchData]);

  const columns = useMemo(
    () => [
      {
        Header: "Procedure Name",
        accessor: "procedure_name",
      },
      {
        Header: "Type",
        accessor: "procedure_type",
        Cell: ({ value }) => value.charAt(0).toUpperCase() + value.slice(1),
      },
      {
        Header: "Doctor Name",
        accessor: "doctors",
        id: "doctor_name",
        Cell: ({ value }) => {
          if (!value || !Array.isArray(value) || value.length === 0) return "N/A";
          // Show first doctor name, or concatenate if multiple
          const doctorNames = value.map(doctor => doctor.doctor_name || doctor.name || "N/A");
          return doctorNames.length === 1 ? doctorNames[0] : `${doctorNames[0]} (+${doctorNames.length - 1} more)`;
        },
      },
      {
        Header: "Clinic",
        accessor: "doctors",
        id: "clinic_name",
        Cell: ({ value }) => {
          if (!value || !Array.isArray(value) || value.length === 0) return "N/A";
          // Show first clinic name
          const firstDoctor = value[0];
          return firstDoctor.clinic_name || firstDoctor.clinic?.name || "N/A";
        },
      },
      {
        Header: "Pricing",
        accessor: "doctors",
        id: "pricing_info",
        Cell: ({ value }) => {
          if (!value || !Array.isArray(value) || value.length === 0) return "N/A";
          // Show first doctor's pricing
          const firstDoctor = value[0];
          const currency = firstDoctor.currency || "PKR";
          const pricing = firstDoctor.pricing || "N/A";
          return pricing !== "N/A" ? `${currency} ${pricing}` : "N/A";
        },
      },
      {
        Header: "Date",
        accessor: "date",
      },
      {
        Header: "Action",
        accessor: "id",
        Cell: ({ row }) => (
          <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
            <button
              className="btn"
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                e.nativeEvent?.stopImmediatePropagation?.();
                setOverviewSurgery(row.original);
                setShowOverviewModal(true);
                return false;
              }}
              style={{
                background: "none",
                border: "none",
                padding: "3px 6px",
                color: "#009B93",
              }}
            >
              <i
                className="fas fa-eye"
                style={{ cursor: "pointer", fontSize: "16px" }}
              ></i>{" "}
              View
            </button>
            <button
              className="btn"
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                e.nativeEvent?.stopImmediatePropagation?.();
                setSelectedSurgery(row.original);
                setShowEditModal(true);
                return false;
              }}
              style={{
                background: "none",
                border: "none",
                padding: "3px 6px",
              }}
            >
              <i
                className="fas fa-pen"
                style={{ color: "#8E8E8E", cursor: "pointer", fontSize: "16px" }}
              ></i>{" "}
              Edit
            </button>
            <Delete data={row.original} surgery={() => fetchData({ pageSize: 10, pageIndex: 0, forceRefresh: true })} />
          </div>
        ),
      },
    ],
    [fetchData]
  );

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: "400px" }}>
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    );
  }

  if (error) {
    return <AlertMessage type="danger" message={error} />;
  }

  if (surgeryList.length === 0 && !isLoading) {
    return (
      <div className="text-center p-5">
        <h5 style={{ color: "#8E8E8E" }}>No surgeries for now</h5>
      </div>
    );
  }

  return (
    <>
      <Table
        columns={columns}
        data={surgeryList}
        fetchData={fetchData}
        pageCount={pageCount}
        loading={isLoading}
        routingLink=""
      />
      <EditSurgeryModal 
        data={selectedSurgery}
        show={showEditModal}
        onHide={() => {
          setShowEditModal(false);
          setSelectedSurgery(null);
        }}
        onSurgeryUpdated={() => {
          fetchData({ pageSize: 10, pageIndex: 0, forceRefresh: true });
        }}
      />

      {/* Overview Modal */}
      <Modal show={showOverviewModal} size="lg" onHide={() => {
        setShowOverviewModal(false);
        setOverviewSurgery(null);
      }} centered>
        <Modal.Header closeButton className="bg-light">
          <Modal.Title className="text-primary">
            <i className="fas fa-eye me-2"></i>
            Surgery Overview
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          {overviewSurgery && (
            <div className="surgery-overview-modal">
              {/* General Information */}
              <div className="mb-4">
                <h5 className="text-primary mb-3 border-bottom pb-2">
                  <i className="fas fa-info-circle me-2"></i>
                  General Information
                </h5>
                <div className="row g-3">
                  <div className="col-md-6">
                    <div className="p-3 bg-light rounded">
                      <div className="mb-2">
                        <strong className="text-muted">Procedure Name:</strong><br />
                        <span className="text-dark">{overviewSurgery.procedure_name || 'N/A'}</span>
                      </div>
                      <div className="mb-2">
                        <strong className="text-muted">Type:</strong><br />
                        <span className="text-dark">{overviewSurgery.procedure_type || 'N/A'}</span>
                      </div>
                      <div className="mb-2">
                        <strong className="text-muted">ID:</strong><br />
                        <span className="text-dark">{overviewSurgery.id || 'N/A'}</span>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    {overviewSurgery.procedure_image_url ? (
                      <div className="p-3 bg-light rounded text-center">
                        <strong className="text-muted d-block mb-2">Procedure Image</strong>
                        <img 
                          src={overviewSurgery.procedure_image_url} 
                          alt="Procedure" 
                          className="img-fluid rounded shadow-sm" 
                          style={{ maxHeight: '150px', objectFit: 'cover' }}
                          onError={(e) => {
                            e.target.style.display = 'none';
                            e.target.nextSibling.style.display = 'block';
                          }}
                        />
                        <div className="text-muted small mt-2" style={{ display: 'none' }}>
                          <i className="fas fa-image me-1"></i>
                          Image not available
                        </div>
                      </div>
                    ) : (
                      <div className="p-3 bg-light rounded text-center">
                        <div className="text-muted">
                          <i className="fas fa-image fa-2x mb-2"></i>
                          <br />
                          <small>No image available</small>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* Doctors Section */}
              <div className="mb-4">
                <h5 className="text-success mb-3 border-bottom pb-2">
                  <i className="fas fa-user-md me-2"></i>
                  Doctors ({overviewSurgery.doctors?.length || 0})
                </h5>
                {overviewSurgery.doctors && overviewSurgery.doctors.length > 0 ? (
                  <div className="row g-3">
                    {overviewSurgery.doctors.map((doctor, index) => (
                      <div key={doctor.doctor_id || index} className="col-lg-6">
                        <div className="p-3 border rounded bg-white shadow-sm h-100">
                          <div className="mb-2">
                            <strong className="text-primary">
                              <i className="fas fa-user me-2"></i>
                              {doctor.name || doctor.doctor_name || 'N/A'}
                            </strong>
                          </div>
                          <div className="mb-2">
                            <strong className="text-muted">Specialization:</strong><br />
                            <span className="text-dark">{doctor.specialization || doctor.doctor_specialization || 'N/A'}</span>
                          </div>
                          {doctor.experience && (
                            <div className="mb-2">
                              <strong className="text-muted">Experience:</strong><br />
                              <span className="text-dark">{doctor.experience} years</span>
                            </div>
                          )}
                          {doctor.rating && (
                            <div className="mb-2">
                              <strong className="text-muted">Rating:</strong><br />
                              <span className="text-warning">
                                <i className="fas fa-star me-1"></i>
                                {doctor.rating}
                              </span>
                            </div>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="text-muted p-3 bg-light rounded">
                    <i className="fas fa-info-circle me-2"></i>
                    No doctor information available
                  </div>
                )}
              </div>

              {/* Clinic & Pricing Details */}
              {overviewSurgery.doctors && overviewSurgery.doctors.length > 0 && (
                <div className="mb-4">
                  <h5 className="text-info mb-3 border-bottom pb-2">
                    <i className="fas fa-clinic-medical me-2"></i>
                    Clinic & Pricing Details
                  </h5>
                  <div className="row g-3">
                    {overviewSurgery.doctors.map((doctor, index) => (
                      <div key={doctor.doctor_id || index} className="col-12">
                        <div className="p-3 border rounded bg-white shadow-sm">
                          <h6 className="text-primary mb-3">
                            <i className="fas fa-user-md me-2"></i>
                            {doctor.name || doctor.doctor_name || 'N/A'}
                          </h6>
                          <div className="row g-3">
                            <div className="col-md-6">
                              <div className="mb-2">
                                <strong className="text-muted">Clinic Name:</strong><br />
                                <span className="text-dark">{doctor.clinic?.name || doctor.clinic_name || 'N/A'}</span>
                              </div>
                              <div className="mb-2">
                                <strong className="text-muted">City:</strong><br />
                                <span className="text-dark">{doctor.clinic?.city || doctor.city || 'N/A'}</span>
                              </div>
                              <div className="mb-2">
                                <strong className="text-muted">Address:</strong><br />
                                <span className="text-dark">{doctor.clinic?.address || doctor.clinic_address || 'N/A'}</span>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="mb-2">
                                <strong className="text-muted">Price:</strong><br />
                                <span className="text-success fw-bold">
                                  {doctor.currency || overviewSurgery.currency || 'PKR'} {doctor.pricing || 'N/A'}
                                </span>
                              </div>
                              {doctor.image_url ? (
                                <div className="mt-2">
                                  <strong className="text-muted d-block mb-2">Doctor Image</strong>
                                  <img 
                                    src={doctor.image_url} 
                                    alt="Doctor" 
                                    className="img-fluid rounded shadow-sm" 
                                    style={{ maxHeight: '100px', objectFit: 'cover' }}
                                    onError={(e) => {
                                      e.target.style.display = 'none';
                                      e.target.nextSibling.style.display = 'block';
                                    }}
                                  />
                                  <div className="text-muted small mt-1" style={{ display: 'none' }}>
                                    <i className="fas fa-image me-1"></i>
                                    Image not available
                                  </div>
                                </div>
                              ) : (
                                <div className="mt-2">
                                  <div className="text-muted small">
                                    <i className="fas fa-user-md me-1"></i>
                                    No image available
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Description */}
              <div>
                <h5 className="text-secondary mb-3 border-bottom pb-2">
                  <i className="fas fa-align-left me-2"></i>
                  Description
                </h5>
                <div className="p-3 bg-light rounded">
                  <p className="mb-0 text-dark">{overviewSurgery.description || 'No description available'}</p>
                </div>
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer className="bg-light">
          <button className="btn btn-outline-secondary" onClick={() => {
            setShowOverviewModal(false);
            setOverviewSurgery(null);
          }}>
            <i className="fas fa-times me-2"></i>
            Close
          </button>
        </Modal.Footer>
      </Modal>
      <style jsx="true">{`
        .pagination > div:last-child {
          display: none !important;
        }
        .pagination > div:last-child button {
          display: none !important;
        }
      `}</style>
    </>
  );
}
